import React, { useCallback, useMemo, useState } from 'react';
import { BaseComponentProps } from '../types';

export enum ReservedKeys {
  CustomerPhoneNumber = 'customer.phone_number',
}

export type ForceRenderContextContextType = {
  findKey: (key: string) => number;
  forceRender: (key: string) => void;
};

export const ForceRenderContext = React.createContext<ForceRenderContextContextType>(null);

export default function ForceRenderProvider({ children }: BaseComponentProps) {
  const [keyStorage, setKeyStorage] = useState({});

  const findKey = useCallback((key: string) => keyStorage[key] ?? 0, [keyStorage]);

  const forceRender = useCallback(
    (key: string) =>
      setKeyStorage((current) => ({
        ...current,
        [key]: (current[key] ?? 0) + 1,
      })),
    [keyStorage],
  );

  const context = useMemo(
    () => ({
      findKey,
      forceRender,
    }),
    [keyStorage],
  );

  return <ForceRenderContext.Provider value={context}>{children}</ForceRenderContext.Provider>;
}
